import { useTranslation } from 'next-i18next'
import { ChangeEvent } from 'react'

import styles from '../css/SelectOptions.module.css'

interface Props {
  options: Record<string, string>
  className?: string
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  translationPrefix?: string
  selectedFilter: string
}

export default function SelectOptions({
  options,
  className = '',
  onChange,
  selectedFilter,
  translationPrefix = '',
}: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  return (
    <div>
      <select className={`${styles['select']} cursor-pointer outline-0 ${className}`} onChange={onChange}>
        {Object.values(options).map((elem) => (
          <option key={elem} selected={selectedFilter === elem} value={elem}>
            {translationPrefix ? t(`${translationPrefix}.${elem}`) : t(elem)}
          </option>
        ))}
      </select>
    </div>
  )
}
